// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resource-card[data-v-4a52c8dc]{border:1px solid #f2f2f2;border-radius:6px;box-shadow:1px 4px 43px -9px rgba(124,122,144,.15)}.provider-image[data-v-4a52c8dc]{border-radius:19.875px}", ""]);
// Exports
module.exports = exports;
